// Shared by both forks.
import React from 'react';
import type { HighlightSegment } from '../helpers/highlightedText';

type Props = {
	segments: HighlightSegment[];
};

// Renders a dropdown search result text with its matched parts in bold. Everything is rendered as React text,
// never as HTML, so result values can't inject markup. Unstyled: the caller's wrapper styles it.
export function HighlightedText({ segments }: Props) {
	return (
		<>
			{/* The segments come from one immutable string, so their order is their identity. */}
			{segments.map(({ text, highlighted }, index) =>
				highlighted ? (
					// eslint-disable-next-line react/no-array-index-key
					<b key={index}>{text}</b>
				) : (
					// eslint-disable-next-line react/no-array-index-key
					<React.Fragment key={index}>{text}</React.Fragment>
				),
			)}
		</>
	);
}
